import { employeeStatusOptions } from 'modules/core/components/EmployeeMultiFilters/commonOptions'
import {
  legalEntityOptions,
  locationOptions,
  teamOptions,
} from 'modules/core/components/MultiFilters/commonOptions'
import type { FilterOption } from 'modules/core/components/MultiFilters/types'
import i18n from 'modules/core/lib/i18n'

const filterFields: () => Promise<FilterOption[]> = async () => {
  return [
    {
      label: i18n.t('filters.multi_filters.employee_status'),
      value: 'employee_status',
      type: 'equal_choice',
      options: await employeeStatusOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.location'),
      value: 'location',
      type: 'single_choice',
      options: await locationOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.team'),
      value: 'team',
      type: 'single_choice',
      options: await teamOptions(),
    },
    {
      label: i18n.t('filters.multi_filters.legal_entity'),
      value: 'legal_entity',
      type: 'single_choice',
      options: await legalEntityOptions(),
    },
  ]
}

export default filterFields
